import { render, staticRenderFns } from "./CoursesListView.vue?vue&type=template&id=0e4b246a&"
import script from "./CoursesListView.vue?vue&type=script&lang=ts&"
export * from "./CoursesListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports